import React, { useState, useEffect } from "react";
import Avatar from "react-avatar";

const getImgUrl = (img) => {
  if (!img || img === "null" || img === "undefined") return null;
  if (img.startsWith("http")) return img;
  const base = (process.env.REACT_APP_BASE_URL || "http://localhost:5026/api/v1").split("/api/v1")[0];
  if (img.includes("/")) {
    const norm = img.startsWith("/") ? img : `/${img}`;
    return `${base}${norm.startsWith("/public") ? norm : `/public${norm}`}`;
  }
  return (process.env.REACT_APP_USER_DOCS_PATH || `${base}/public/users/docs/`) + img;
};

const UserProfile = ({ username, userImage, style, bgColor }) => {
  const [resolvedUrl, setResolvedUrl] = useState(null);

  useEffect(() => {
    const url = getImgUrl(userImage);
    if (!url) { setResolvedUrl(null); return; }
    setResolvedUrl(null);
    const img = new Image();
    img.onload  = () => setResolvedUrl(url);
    img.onerror = () => setResolvedUrl(null);
    img.src = url;
  }, [userImage]);

  const rawWidth  = style?.width  || "30";
  const rawHeight = style?.height || "30";
  const getCssValue = (val) =>
    typeof val === "string" && val.includes("%") ? val : `${String(val).replace("px", "")}px`;
  const width  = getCssValue(rawWidth);
  const height = getCssValue(rawHeight);

  const imageStyle = {
    ...style,
    width,
    height,
    minWidth: width,
    minHeight: height,
    objectFit: "cover",
    objectPosition: "center",
  };

  return (
    <>
      {resolvedUrl ? (
        <img
          className="rounded"
          src={resolvedUrl}
          alt={username}
          style={imageStyle}
          width={width.replace("px", "")}
          height={height.replace("px", "")}
        />
      ) : (
        <Avatar
          className="rounded"
          name={username}
          maxInitials={2}
          size={width.replace("px", "")}
          round="8px"
          textSizeRatio={3}
          color={bgColor || "#0DDFAB"}
          style={{ 
            ...style, 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            fontWeight: "600"
          }}
        />
      )}
    </>
  );
};

export default UserProfile;
